import React from 'react';
import LanguageSwitcher from './LanguageSwitcher';
import bookMarketLogo from '../assets/book-market-logo.png';

interface Props {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  wide?: boolean;
}

/** Centered card used by the sign-in / sign-up / password pages. */
const AuthShell: React.FC<Props> = ({ title, subtitle, children, wide }) => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 py-8 sm:py-12 px-4 sm:px-6 lg:px-8">
    <div className={`${wide ? 'max-w-lg' : 'max-w-md'} w-full space-y-6`}>
      <div className="flex justify-end">
        <LanguageSwitcher />
      </div>
      <div>
        <img src={bookMarketLogo} alt="BookMarketLk" className="mx-auto h-20 sm:h-24 w-auto" />
        <h2 className="mt-4 sm:mt-6 text-center text-2xl sm:text-3xl font-extrabold text-gray-900">{title}</h2>
        {subtitle && <p className="mt-2 text-center text-sm text-gray-600">{subtitle}</p>}
      </div>
      {children}
    </div>
  </div>
);

export default AuthShell;

export const inputClass =
  'appearance-none block w-full px-3 sm:px-4 py-3 sm:py-2.5 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-md focus:outline-none focus:ring-blue-500 focus:border-blue-500 text-base sm:text-sm';

export const primaryButtonClass =
  'w-full flex justify-center items-center py-3 sm:py-2.5 px-4 border border-transparent text-base sm:text-sm font-medium rounded-md text-white bg-blue-600 active:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 disabled:opacity-50 disabled:cursor-not-allowed min-h-[44px] touch-manipulation';

export const ErrorBox: React.FC<{ message: string }> = ({ message }) =>
  message ? (
    <div className="rounded-md bg-red-50 border border-red-200 p-3 sm:p-4">
      <p className="text-sm text-red-800">{message}</p>
    </div>
  ) : null;
